// Fechas relativas y tamaños, en inglés como el resto de la interfaz.
import { t } from './i18n/index.ts';

export function ago(ms: number | null | undefined, now = Date.now()): string {
  if (!ms) return t('time.never');
  const s = Math.max(0, Math.round((now - ms) / 1000));
  if (s < 45) return t('time.justNow');
  const m = Math.round(s / 60);
  if (m < 60) return t('time.minutesAgo', { n: m });
  const h = Math.round(m / 60);
  if (h < 24) return t('time.hoursAgo', { n: h });
  const d = Math.round(h / 24);
  if (d < 30) return t('time.daysAgo', { n: d });
  return new Date(ms).toLocaleDateString('en-GB', { day: 'numeric', month: 'short', year: 'numeric' });
}

export function fullDate(ms: number | null | undefined): string {
  if (!ms) return '';
  return new Date(ms).toLocaleString('en-GB', { dateStyle: 'medium', timeStyle: 'short' });
}

export function bytes(n: number | undefined): string {
  if (n === undefined) return '';
  if (n < 1024) return `${n} B`;
  if (n < 1024 * 1024) return `${(n / 1024).toFixed(1)} KB`;
  if (n < 1024 * 1024 * 1024) return `${(n / 1024 / 1024).toFixed(1)} MB`;
  return `${(n / 1024 / 1024 / 1024).toFixed(2)} GB`;
}
